<app-navbar></app-navbar>
<div class="main-nav-bar">
    <nav class="main-nav" aria-label="Navegação principal">
        <button type="button" class="main-nav__item"
            [class.main-nav__item--active]="!selectedIndex"
            [attr.aria-current]="!selectedIndex ? 'page' : null"
            [disabled]="disabled"
            (click)="select(0)">
            <svg class="main-nav__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2z"/>
                <line x1="9" y1="7" x2="9" y2="17" stroke-dasharray="3 2"/>
            </svg>
            <span class="main-nav__label">Meus Voos</span>
        </button>
        <button type="button" class="main-nav__item"
            [class.main-nav__item--active]="selectedIndex === 1"
            [attr.aria-current]="selectedIndex === 1 ? 'page' : null"
            [disabled]="disabled"
            (click)="select(1)">
            <svg class="main-nav__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <path d="M16 2v4M8 2v4M3 10h18M12 14v4M10 16h4"/>
            </svg>
            <span class="main-nav__label">Nova Reserva</span>
        </button>
    </nav>
</div>
<div class="container_voos">
    <mat-tab-group [(selectedIndex)]="selectedIndex" animationDuration="0ms">
        <mat-tab label="Meus Voos" [disabled]="disabled">
            <app-my-flights></app-my-flights>
        </mat-tab>
        <mat-tab label="Nova Reserva" [disabled]="disabled">
            <ng-content select="[newReservation]"></ng-content>
        </mat-tab>
    </mat-tab-group>
</div>
